import React from 'react';
import PropTypes from 'prop-types';
import { spaces } from '@firsttable/web-theme';
import Title from '../../atoms/Title';
import Text from '../../atoms/Text';
import Box from '../../atoms/Box';
import Flex from '../../atoms/Flex';

const rowHeadDefaultMb = ['10px', '50px'];
const RowHead = ({
  title = '',
  children = null,
  subTitle = '',
  subTitleSize = 'xl',
  titleSize = 'h1',
  icon = null,
  justifyContent = 'center',
  mb = rowHeadDefaultMb,
  ...rawRest
}: {
  title?: any;
  children?: any;
  mb?: any;
  subTitle?: string;
  subTitleSize?: number | string;
  titleSize?: number | string;
  icon?: any;
  justifyContent?: string | string[];
}) => (
  <Box {...spaces({ ...rawRest, mb })}>
    {title ? (
      <Flex justifyContent={justifyContent}>
        <Box
          maxWidth={icon ? ['none', '65%'] : null}
          position="relative"
          minHeight={['none', 108]}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          {icon && (
            <Box
              display={['none', 'block']}
              position="absolute"
              top="50%"
              left={-150}
              style={{
                transform: 'translateY(-50%)',
              }}
            >
              {icon}
            </Box>
          )}
          <Title as="h1" size={titleSize} mb="xs" textAlign={['center']}>
            {title}
          </Title>
          {subTitle && (
            <Text
              letterSpacing="-0.5px"
              fontSize={subTitleSize}
              textAlign={['center']}
            >
              {subTitle}
            </Text>
          )}
        </Box>
      </Flex>
    ) : (
      children
    )}
  </Box>
);

RowHead.propTypes = {
  title: PropTypes.any,
  children: PropTypes.any,
  subTitle: PropTypes.string,
  mb: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
  subTitleSize: PropTypes.string,
  titleSize: PropTypes.string,
  justifyContent: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};

export default RowHead;
